module.exports = __webpack_public_path__ + "static/media/Appstore.ba16986d.svg";